import Api from './Api';

export async function fetchElasticQuery(index: string, query?: object) {
  return Api.put(`/elastic/${index}/`, query).then(response => response.data);
}
